// @ts-nocheck
/**
 * builtinLayoutDescriptors.ts — Preview/editor pipeline helper for renderAsBuiltin layouts.
 *
 * Live canvas items with renderAsBuiltin route through ItemCanvasElement
 * (see ObjectRendererSwitch), not these descriptors.
 */

import type { ItemDefinition } from '../../../../../shims/appStub';
import type { RenderDescriptor } from '../renderer/types';

export function buildBuiltinLayoutDescriptors(
  item: ItemDefinition,
  layoutId: string,
): RenderDescriptor[] {
  const title = item.title ?? '';
  const amount = item.amount ?? 0;

  return [
    {
      nodeId: `${layoutId}::builtin-title`,
      type: 'text',
      layout: { x: 0.08, y: 0.2, width: 0.84, height: 0.25, zIndex: 0 },
      visible: true,
      enabled: true,
      props: { value: title },
    },
    {
      nodeId: `${layoutId}::builtin-amount`,
      type: 'number',
      layout: { x: 0.08, y: 0.55, width: 0.84, height: 0.2, zIndex: 1 },
      visible: true,
      enabled: true,
      props: { value: amount },
    },
  ];
}
